import { render, staticRenderFns } from "./OldWomanIcon.vue?vue&type=template&id=fc46f134"
import script from "./OldWomanIcon.vue?vue&type=script&lang=js"
export * from "./OldWomanIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports